export default {
      id: "remove-operative-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#remove-operative",
      toString: function () {
        return this.url;
      }
    }